import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[appCurrencyMask]",
})
export class CurrencyMaskDirective {
  private isFormatting = false;

  private formatCurrencyInput(rawValue: string): string {
    if (!rawValue) {
      return "";
    }

    const digitsOnly = rawValue.replace(/\D/g, "");
    if (!digitsOnly) {
      return "";
    }

    if (digitsOnly.length < 3) {
      return digitsOnly;
    }

    const normalized = digitsOnly.replace(/^0+(?=\d)/, "");
    const padded = normalized.padStart(3, "0");
    const intPartRaw = padded.slice(0, -2).replace(/^0+(?=\d)/, "") || "0";
    const decPart = padded.slice(-2);
    const formattedInt = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `${formattedInt},${decPart}`;
  }

  @HostListener("focus", ["$event"])
  onFocus(event: any) {
    if (event.target.value === "0,00") {
      event.target.value = "";
    }
  }

  @HostListener("input", ["$event"])
  addMask(event: any) {
    if (this.isFormatting) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const formattedValue = this.formatCurrencyInput(input.value);
    if (input.value === formattedValue) {
      return;
    }

    this.isFormatting = true;
    input.value = formattedValue;

    const cursorPosition = input.value.length;
    input.setSelectionRange(cursorPosition, cursorPosition);

    input.dispatchEvent(new Event("input", { bubbles: true }));
    this.isFormatting = false;
  }
}
